import {observer} from 'mobx-react';
import Highlight from 'shared/components/Highlight';

const NavigationSuggestion = observer(({viewModel, query}) => {
  return (
    <a href={viewModel.data.link} className='tuatara text-decoration-none'>
      <div className={`searchable-dropdown-item ${viewModel.selected ? 'selected' : ''} `}>
        <div className={`clearfix table full-width ${viewModel.data.detail ? '' : 'py1'}`}>
          <div className='table-cell align-middle col-1 center'>
            <i className='material-symbols-solid align-middle h2'>{viewModel.data.args.icon}</i>
          </div>
          <div className='table-cell align-middle col-11 pl2'>
            <div>
              <Highlight searchQuery={query}>
                {viewModel.data.caption}
              </Highlight>
            </div>
            <div className='searchable-dropdown-item-detail'>
              {viewModel.data.detail}
            </div>
          </div>
        </div>
      </div>
    </a>
  );
});

export default NavigationSuggestion;
